module.exports = __webpack_public_path__ + "img/filter-welcome-background-mitsu.e1f143f5.png";